export const getReportNames = () => ([
  {
    key: 'weekly_provider_actuation_summary',
    name: 'Provider Actuation (Weekly Summary)',
    // Component: WeeklyProviderActuationSummaryReport,
  },
]);